<template>
  <div class="wrap">
    <!-- 未登录状态 -->
    <template v-if="!isLogin">
      <el-empty description="未登录" class="n">
        <el-button type="primary" @click="$router.push('login')"
          >去登录</el-button
        >
      </el-empty>
    </template>

    <!-- 登录后 -->
    <logined-home v-else />
  </div>
</template>

<script>
import { courseList } from "@/api/course";
import loginedHome from "./loginedHome.vue";
export default {
  components: {
    loginedHome,
  },
  data() {
    return {
      bannerList: [
        {
          bannerId: "1",
          img: require("@/assets/images/banners/banner.png"),
        },
      ],
      // params: {
      //   pageNum: 1,
      //   pageSize: 8,
      // },
      // total: 5,
      lessonList: [],
    };
  },
  created() {
    this.getCourseList();
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    getCourseList() {
      this.$loading.show();
      courseList().then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.lessonList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 翻页
    // pageChange() {},
  },
};
</script>

<style lang="less" scoped>
.wrap {
  position: relative;
  // min-height: calc(100vh - 66px - 200px);
  background-color: rgb(248, 248, 248);
  .n {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .banner {
    background-image: linear-gradient(
      to right,
      rgb(46, 17, 83),
      rgb(46, 17, 83),
      rgb(60, 30, 102),
      rgb(60, 30, 102)
    );
    .banner_item {
      width: 100%;
      height: 100%;
    }
  }

  .main {
    text-align: left;
    overflow: unset;

    .title {
      margin-top: 30px;
      margin-bottom: 22px;
      padding-left: 20px;
      border-left: 2px solid #1976f5;
      line-height: 1;
      font-size: 24px;
      font-weight: bold;
    }

    .box {
      .lesson {
        display: inline-block;
        margin-bottom: 16px;
        width: 227px;
        border-radius: 10px;
        box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.2);
        overflow: hidden;

        &:not(:nth-child(5n)) {
          margin-right: 16px;
        }

        &:hover {
          .cover {
            transform: scale(1.1, 1.1);
          }
        }

        .cover_box {
          width: 227px;
          height: 152px;
          overflow: hidden;
        }

        .cover {
          width: 100%;
          height: 100%;
          transition: all 0.5s ease;
        }

        .lesson_info {
          padding: 15px;

          .lesson_title {
            max-width: 130px;
            color: #1976f5;
            font-size: 16px;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .counts {
            padding: 10px;

            .count_item {
              display: inline-block;
              margin: 0 5px;
              text-align: center;
              font-size: 14px;
              color: #000;
            }
          }

          .bottom {
            overflow: hidden;

            .complete_num {
              float: left;
              color: #000;
              font-size: 16px;
              line-height: 36px;
            }

            .btn {
              float: right;
              padding: 0;
              width: 100px;
              height: 36px;
              line-height: 36px;
              background: #1976f5;
            }
          }
        }
      }
    }
  }

  .foot_page {
    margin-top: 14px;
    margin-bottom: 30px;
    text-align: right;

    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #0d79ff;
    }
  }
}
</style>